export default __webpack_public_path__ + "static/media/question.3d0a0c91.svg";